import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { Container } from 'react-bootstrap';

export default function Error(props) {
  return (
    <>
    <Header isLogin={props.isLogin} setIsLogin={props.setIsLogin} />
        <Container>
            <div className="d-flex align-items-center justify-content-center" style={{height: 'calc(100vh - 154px)'}}>
                <div className='bgs-blue col-md-8 col-lg-6 col-xl-5 mx-3 mx-sm-auto p-3 p-sm-5 br-30 text-center'>
                    <h1>404 - Page Not Found</h1>
                    <p className='mb-0'>Sorry, the page you are looking for does not exist.</p>
                </div>
            </div>
        </Container>
    <Footer />
    </>
  )
}
